import ConversationItemType from 'models/conversation_item_type';
import { EndpointTypes } from 'models/endpoint';
import { MessageChannelType } from 'models/conversation_message';

// Maps a rendered conversation item to the EndpointType whose color preference
// tints its bubble. Distinct from models/interaction_type's getInteractionType:
// that emits InteractionType (used by reporting/liveboards) and keeps PHONE_CALL,
// VOICEMAIL, ABANDONED_CALL separate, whereas bubbles collapse every voice/AI/
// campaign subtype onto the single VOICE endpoint and key off EndpointTypes.
const TYPE_TO_ENDPOINT = {
  [ConversationItemType.CHAT]: EndpointTypes.CHAT,
  [ConversationItemType.CHAT_MESSAGE]: EndpointTypes.CHAT,
  [ConversationItemType.SMS]: EndpointTypes.SMS,
  [ConversationItemType.SMS_CAMPAIGN_OUTREACH]: EndpointTypes.SMS,
  [ConversationItemType.SMS_CAMPAIGN_OUTREACH_RESULT]: EndpointTypes.SMS,
  [ConversationItemType.EMAIL]: EndpointTypes.EMAIL,
  [ConversationItemType.EMAIL_PREVIEW]: EndpointTypes.EMAIL,
  [ConversationItemType.EMAIL_CAMPAIGN_OUTREACH]: EndpointTypes.EMAIL,
  [ConversationItemType.EMAIL_CAMPAIGN_OUTREACH_RESULT]: EndpointTypes.EMAIL,
  [ConversationItemType.MARKETING_EMAIL]: EndpointTypes.EMAIL,
  [ConversationItemType.PHONE_CALL]: EndpointTypes.VOICE,
  [ConversationItemType.PHONE_CALLBACK]: EndpointTypes.VOICE,
  [ConversationItemType.ABANDONED_CALL]: EndpointTypes.VOICE,
  [ConversationItemType.VOICEMAIL]: EndpointTypes.VOICE,
  [ConversationItemType.VOICE_AI_CALL]: EndpointTypes.VOICE,
  [ConversationItemType.VOICE_AI_MESSAGE]: EndpointTypes.VOICE,
  [ConversationItemType.VOICE_AI_RECORDING]: EndpointTypes.VOICE,
  [ConversationItemType.VOICE_CAMPAIGN_OUTREACH]: EndpointTypes.VOICE,
  [ConversationItemType.VOICE_CAMPAIGN_OUTREACH_RESULT]: EndpointTypes.VOICE,
  [ConversationItemType.FB_MESSAGE_INCOMING]: EndpointTypes.FB_MESSENGER,
  [ConversationItemType.FB_MESSAGE_OUTGOING]: EndpointTypes.FB_MESSENGER,
  [ConversationItemType.CUSTOM_CHANNEL_MESSAGE]: EndpointTypes.CUSTOM_CHANNEL,
  [ConversationItemType.TWITTER]: EndpointTypes.TWITTER,
};

const MESSAGE_CHANNEL_TO_ENDPOINT = {
  [MessageChannelType.FB_COMMENT]: EndpointTypes.FB_COMMENT,
  [MessageChannelType.WHATSAPP]: EndpointTypes.WHATSAPP,
  [MessageChannelType.TWITTER]: EndpointTypes.TWITTER,
  [MessageChannelType.INSTAGRAM_DIRECT]: EndpointTypes.INSTAGRAM_DIRECT,
  [MessageChannelType.INSTAGRAM_COMMENT]: EndpointTypes.INSTAGRAM_COMMENT,
};

export default function endpointTypeForConversationItem(item) {
  if (!item || typeof item.contentType !== 'function') return undefined;
  const contentType = item.contentType();

  if (contentType === ConversationItemType.CONVERSATION_MESSAGE) {
    const channel = item.content && item.content.channel;
    return MESSAGE_CHANNEL_TO_ENDPOINT[channel];
  }

  return TYPE_TO_ENDPOINT[contentType];
}
